import { AdminTypeAheadQuery, useAdminTypeAheadQuery } from 'graphql/bindings/AdminBindings'
import { AsyncAutocompleteFieldType, HookAutocompleteField } from 'components/shared/dropdowns'
import React from 'react'

export const transformAdminTypeahead = (data: AdminTypeAheadQuery) =>
  data.adminTypeAhead.map(elem => {
    const name = elem.first_name + ' ' + elem.last_name
    return {
      label: name,
      value: elem.id,
    }
  })

export const AdminField: React.FC<AsyncAutocompleteFieldType> = props => {
  return <HookAutocompleteField useQuery={useAdminTypeAheadQuery} transform={transformAdminTypeahead} {...props} />
}
